export default "__VITE_ASSET__554293ce__"